import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo_2.png'
import _imports_1 from '@/assets/img/demo_image.jpg'

const _withId = /*#__PURE__*/_withScopeId("data-v-4beeaccd")

_pushScopeId("data-v-4beeaccd")
const _hoisted_1 = { id: "bodyWrap" }
const _hoisted_2 = { class: "demoPage" }
const _hoisted_3 = { class: "demoSection" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "wrapper" }
const _hoisted_6 = { class: "titleBlock" }
const _hoisted_7 = { class: "pageTitle" }
const _hoisted_8 = { class: "contentBlock" }
const _hoisted_9 = { class: "demoInfo" }
const _hoisted_10 = { class: "productCard" }
const _hoisted_11 = { class: "name" }
const _hoisted_12 = { class: "description" }
const _hoisted_13 = {
  href: "#",
  class: "more"
}
const _hoisted_14 = { class: "productInfo" }
const _hoisted_15 = { class: "item dropdownItem" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = { class: "btn" }
const _hoisted_18 = { class: "in" }
const _hoisted_19 = { class: "item dropdownItem" }
const _hoisted_20 = { class: "title" }
const _hoisted_21 = { class: "btn" }
const _hoisted_22 = { class: "in" }
const _hoisted_23 = { class: "item dropdownItem" }
const _hoisted_24 = { class: "title" }
const _hoisted_25 = { class: "btn" }
const _hoisted_26 = { class: "in" }
const _hoisted_27 = { class: "item dropdownItem" }
const _hoisted_28 = { class: "title" }
const _hoisted_29 = { class: "btn" }
const _hoisted_30 = { class: "in" }
const _hoisted_31 = { class: "buy" }
const _hoisted_32 = /*#__PURE__*/_createVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: "logo"
  })
], -1)
const _hoisted_33 = { class: "text" }
const _hoisted_34 = { class: "cost" }
const _hoisted_35 = { class: "demoSlider scrollSlider" }
const _hoisted_36 = /*#__PURE__*/_createVNode("div", {
  class: "main scrollBlock mCustomScrollbar _mCS_1 scroller",
  id: "test-scroll",
  style: {"overflow-y":"auto"}
}, [
  /*#__PURE__*/_createVNode("div", {
    id: "mCSB_1",
    class: "mCS-light mCSB_vertical mCSB_inside",
    style: {"max-height":"none"},
    tabindex: "0"
  }, [
    /*#__PURE__*/_createVNode("div", {
      id: "mCSB_1_container",
      class: "mCSB_container",
      dir: "ltr"
    }, [
      /*#__PURE__*/_createVNode("div", { class: "inner" }, [
        /*#__PURE__*/_createVNode("div", { class: "item" }, [
          /*#__PURE__*/_createVNode("div", { class: "in" }, [
            /*#__PURE__*/_createVNode("img", {
              src: _imports_1,
              alt: "demo",
              class: "mCS_img_loaded"
            })
          ])
        ]),
        /*#__PURE__*/_createVNode("div", { class: "item" }, [
          /*#__PURE__*/_createVNode("div", { class: "in" }, [
            /*#__PURE__*/_createVNode("img", {
              src: _imports_1,
              alt: "demo",
              class: "mCS_img_loaded"
            })
          ])
        ]),
        /*#__PURE__*/_createVNode("div", { class: "item" }, [
          /*#__PURE__*/_createVNode("div", { class: "in" }, [
            /*#__PURE__*/_createVNode("img", {
              src: _imports_1,
              alt: "demo",
              class: "mCS_img_loaded"
            })
          ])
        ]),
        /*#__PURE__*/_createVNode("div", { class: "item" }, [
          /*#__PURE__*/_createVNode("div", { class: "in" }, [
            /*#__PURE__*/_createVNode("img", {
              src: _imports_1,
              alt: "demo",
              class: "mCS_img_loaded"
            })
          ])
        ]),
        /*#__PURE__*/_createVNode("div", { class: "item" }, [
          /*#__PURE__*/_createVNode("div", { class: "in" }, [
            /*#__PURE__*/_createVNode("img", {
              src: _imports_1,
              alt: "demo",
              class: "mCS_img_loaded"
            })
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_37 = { class: "preview" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Header = _resolveComponent("Header")
  const _component_PaymentModal = _resolveComponent("PaymentModal")
  const _component_Footer = _resolveComponent("Footer")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Header),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("span", _hoisted_7, _toDisplayString(_ctx.t("demoPage.pageTitle")), 1)
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    _createVNode("span", null, _toDisplayString(_ctx.t("demoPage.productCard.name")), 1)
                  ]),
                  _createVNode("div", _hoisted_12, [
                    _createVNode("p", null, _toDisplayString(_ctx.t("demoPage.productCard.description")), 1)
                  ]),
                  _createVNode("a", _hoisted_13, _toDisplayString(_ctx.t("demoPage.productCard.more")), 1),
                  _createVNode("div", _hoisted_14, [
                    _createVNode("div", _hoisted_15, [
                      _createVNode("div", {
                        class: ["head", { active: _ctx.isActive(0) }]
                      }, [
                        _createVNode("span", _hoisted_16, _toDisplayString(_ctx.t("demoPage.item[0].title")), 1),
                        _createVNode("div", _hoisted_17, [
                          _createVNode("span", {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.spanClicked(0)))
                          }),
                          _createVNode("span", {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.spanClicked(0)))
                          })
                        ])
                      ], 2),
                      _createVNode("div", {
                        class: ["content", { show: _ctx.isActive(0) }]
                      }, [
                        _createVNode("div", _hoisted_18, [
                          _createVNode("p", null, _toDisplayString(_ctx.t("demoPage.item[0].para[0]")), 1),
                          _createVNode("p", null, _toDisplayString(_ctx.t("demoPage.item[0].para[1]")), 1),
                          _createVNode("p", null, _toDisplayString(_ctx.t("demoPage.item[0].para[2]")), 1)
                        ])
                      ], 2)
                    ]),
                    _createVNode("div", _hoisted_19, [
                      _createVNode("div", {
                        class: ["head", { active: _ctx.isActive(1) }]
                      }, [
                        _createVNode("span", _hoisted_20, _toDisplayString(_ctx.t("demoPage.item[1].title")), 1),
                        _createVNode("div", _hoisted_21, [
                          _createVNode("span", {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.spanClicked(1)))
                          }),
                          _createVNode("span", {
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.spanClicked(1)))
                          })
                        ])
                      ], 2),
                      _createVNode("div", {
                        class: ["content", { show: _ctx.isActive(1) }]
                      }, [
                        _createVNode("div", _hoisted_22, [
                          _createVNode("p", null, _toDisplayString(_ctx.t("demoPage.item[1].para[0]")), 1)
                        ])
                      ], 2)
                    ]),
                    _createVNode("div", _hoisted_23, [
                      _createVNode("div", {
                        class: ["head", { active: _ctx.isActive(2) }]
                      }, [
                        _createVNode("span", _hoisted_24, _toDisplayString(_ctx.t("demoPage.item[2].title")), 1),
                        _createVNode("div", _hoisted_25, [
                          _createVNode("span", {
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.spanClicked(2)))
                          }),
                          _createVNode("span", {
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.spanClicked(2)))
                          })
                        ])
                      ], 2),
                      _createVNode("div", {
                        class: ["content", { show: _ctx.isActive(2) }]
                      }, [
                        _createVNode("div", _hoisted_26, [
                          _createVNode("p", null, _toDisplayString(_ctx.t("demoPage.item[2].para[0]")), 1)
                        ])
                      ], 2)
                    ]),
                    _createVNode("div", _hoisted_27, [
                      _createVNode("div", {
                        class: ["head", { active: _ctx.isActive(3) }]
                      }, [
                        _createVNode("span", _hoisted_28, _toDisplayString(_ctx.t("demoPage.item[3].title")), 1),
                        _createVNode("div", _hoisted_29, [
                          _createVNode("span", {
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.spanClicked(3)))
                          }),
                          _createVNode("span", {
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.spanClicked(3)))
                          })
                        ])
                      ], 2),
                      _createVNode("div", {
                        class: ["content", { show: _ctx.isActive(3) }]
                      }, [
                        _createVNode("div", _hoisted_30, [
                          _createVNode("p", null, _toDisplayString(_ctx.t("demoPage.item[3].para[0]")), 1)
                        ])
                      ], 2)
                    ])
                  ]),
                  _createVNode("div", _hoisted_31, [
                    _createVNode("button", {
                      class: "btnIconType5",
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.openmodal && _ctx.openmodal(...args)))
                    }, [
                      _hoisted_32,
                      _createVNode("span", _hoisted_33, _toDisplayString(_ctx.t("demoPage.buy.text")), 1)
                    ]),
                    _createVNode("span", _hoisted_34, [
                      _createVNode("span", null, _toDisplayString(_ctx.t("demoPage.buy.cost1")), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("demoPage.buy.cost2")), 1)
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_35, [
                _hoisted_36,
                _createVNode("div", _hoisted_37, [
                  _createVNode("div", {
                    class: [[_ctx.scrollNo === 0 ? ['active'] : ''], "item"]
                  }, [
                    _createVNode("img", {
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changeScrollBarPos(0, 0))),
                      src: _imports_1,
                      alt: "demo"
                    })
                  ], 2),
                  _createVNode("div", {
                    class: [[_ctx.scrollNo === 1 ? ['active'] : ''], "item"]
                  }, [
                    _createVNode("img", {
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changeScrollBarPos(348, 1))),
                      src: _imports_1,
                      alt: "demo"
                    })
                  ], 2),
                  _createVNode("div", {
                    class: [[_ctx.scrollNo === 2 ? ['active'] : ''], "item"]
                  }, [
                    _createVNode("img", {
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changeScrollBarPos(780, 2))),
                      src: _imports_1,
                      alt: "demo"
                    })
                  ], 2),
                  _createVNode("div", {
                    class: [[_ctx.scrollNo === 3 ? ['active'] : ''], "item"]
                  }, [
                    _createVNode("img", {
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.changeScrollBarPos(1200, 3))),
                      src: _imports_1,
                      alt: "demo"
                    })
                  ], 2),
                  _createVNode("div", {
                    class: [[_ctx.scrollNo === 4 ? ['active'] : ''], "item"]
                  }, [
                    _createVNode("img", {
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.changeScrollBarPos(1544, 4))),
                      src: _imports_1,
                      alt: "demo"
                    })
                  ], 2)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.showModal)
      ? (_openBlock(), _createBlock(_component_PaymentModal, {
          key: 0,
          onClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showModal = false))
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Footer)
  ]))
})